// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4ijJ1","textarea":"styles_textarea__54erX","scrollArea":"styles_scrollArea__QvgEq","label":"styles_label__9f70w","active":"styles_active__sCW-i"};